<oph-button
  color="green"
  class="update-button"
  (buttonClick)="buttonClick.emit()"
  [style]="{width: '100%', borderRadius: '10px', padding: '0 15px', height: '46px'}"
  [disabled]="disabled"
>
  <div class="button-content">
    <div class="update-check">
      @if ((loading?.subtaskIndex === subtaskIndex && loading?.metricStatus === 'loading') || loading?.checkbox) {
        <div class="oph-green-spinner">
          <mat-spinner [diameter]="16"></mat-spinner>
        </div>
      } @else if (loading?.subtaskIndex === subtaskIndex && loading?.metricStatus === 'success') {
        <img src="assets/img/icons/check-green.svg" class="green-check" />
      } @else {
        <img src="assets/img/icons/check-light-grey.svg" />
      }
    </div>
    <span class="button-text">{{ buttonText }}</span>
  </div>
</oph-button>
